import { logoutWtApp } from "../androidAndIosApp";
import { isAppTypeIframe } from "../getAppType";
import { useSettings } from "../settings/useSettings";
import { getRedirectProps, redirect } from "./redirect";

export const useLogOut = () => {
  const settings = useSettings();

  return () => {
    if (window.iswtapp) {
      logoutWtApp();
    }

    let params = new URLSearchParams();

    if (window.cvpIdConcern) {
      params.append("k", window.cvpIdConcern.toString());
    }

    let urlToGoToAfterLogout = isAppTypeIframe()
      ? settings.iframe_startPage
      : "/";

    const redirectUri = getRedirectProps(urlToGoToAfterLogout, {
      mergeQs: {
        k: window.cvpIdConcern ?? null,
      },
    }).href;

    const searchParams = new URLSearchParams();
    searchParams.set("redirectUri", redirectUri);
    const qs = searchParams.toString();

    redirect(`${location.origin}/auth/logout?${qs}`, {
      mergeQs: {},
      redirectRaw: true,
    });
  };
};
